import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import {
    SocialProjectClientGridObject,
    SocialProjectClientObject,
} from '@libs/types/src/services/object-type/service/social-project-client.object';
import { SocialProjectClientCreateInput } from '@libs/types/src/services/input-type/services/project-client.create-input';
import { SocialProjectClientUpdateInput } from '@libs/types/src/services/input-type/services/project-client.update-input';
import { filterFrag } from './types/filter.types';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class ServiceSocialProjectClientGqlService extends GqlServiceV2 {

    public getSocialProjectClients(input: GridInput | null, frag: string) {
        return this.query<SocialProjectClientGridObject>(
            `
                query($input: GridInput) {
                    socialProjectClient {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialProjectClient(input: SocialProjectClientCreateInput) {
        return this.mutate<SocialProjectClientObject>(
            `
                mutation($input: SocialProjectClientCreateInput!) {
                    socialProjectClient {
                        create(input: $input) {
                            id
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createManySocialProjectClients(input: SocialProjectClientCreateInput[]) {
        return this.mutate<OkObject>(
            `
                mutation($input: [SocialProjectClientCreateInput!]!) {
                    socialProjectClient {
                        createMany(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateSocialProjectClient(input: SocialProjectClientUpdateInput) {
        return this.mutate<SocialProjectClientObject>(
            `
                mutation($input: SocialProjectClientUpdateInput!) {
                    socialProjectClient {
                        update(input: $input) {
                            id
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialProjectClient(input: IdInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialProjectClient {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
